import { API_URL } from "./Config";
import { GetDummyResponse, IDetailsResponse } from "./IDetailsResponse";

export interface ISiteDetails extends IDetailsResponse {
  address1: string;
  address2: string;
  address3: string;
  city: string;
  county: string;
  eircode: string;
  nacecode: string;
  nutscode: string;
  urbanareape: string;
  plantcapacitype: string;
  treatmenttype: string;
  uvtreatment: string;
  licenceprofileid: string;
}

export async function GetSiteDetailsByProfileIdAsync(
  profileId: string
): Promise<ISiteDetails> {
  var url = `${API_URL}/Site/byprofileid?licence_profile_id=${profileId}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/site`;
  }

  var response = await fetch(url);
  var body = <ISiteDetails>await response.json();

  return body;
}

export const GetSiteByProfileId = (profileId: string): ISiteDetails => {
  return GetSiteDetailsDummy(profileId);
};

export const GetSiteDetailsDummy = (profileId: string): ISiteDetails => {
  return {
    response: GetDummyResponse(),
    address1: "A building",
    address2: "A street",
    address3: "-",
    city: "Sligo (city)",
    county: "Sligo",
    eircode: "F99Z999",
    nacecode: "3821",
    nutscode: "IE051",
    urbanareape: "Urban Area PE",
    plantcapacitype: "capacity",
    treatmenttype: "treatment type",
    uvtreatment: "uv treatment",
    licenceprofileid: profileId,
  };
};
